import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMessage } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { safeHref } from "../../../utils/safeHref";

export default function RequestCardMobile({ request, onMessageIconClick, onDeny, onApprove }) {
  const { t } = useTranslation();
  // Populated by GET /fepks/mine, which only the EPK owner can call.
  const user = request.requester;

  if (!user) return null;

  const picture = user.picture?.startsWith("https")
    ? user.picture
    : user.picture
    ? `${process.env.REACT_APP_AWS_URL}/${user.picture}`
    : null;

  return (
    <div className="tw-flex tw-flex-col tw-gap-3 tw-rounded-xl tw-bg-white/5 tw-border tw-border-white/10 tw-p-3">
      {/* Top row: avatar + info + message btn */}
      <div className="tw-flex tw-items-center tw-gap-3">
        <Link to={`/user/${user._id}`} className="tw-flex-shrink-0">
          <div className="tw-relative tw-h-12 tw-w-12">
            {picture && (
              <img
                className="tw-h-12 tw-w-12 tw-rounded-lg tw-object-cover"
                src={picture}
                alt={`${user.firstName} ${user.lastName}`}
              />
            )}
            <span className="tw-absolute tw-inset-x-0 tw-bottom-0 tw-rounded-b-lg tw-bg-black/50 tw-text-center tw-text-[9px] tw-text-white tw-leading-tight tw-py-0.5">
              {t(user.role)}
            </span>
          </div>
        </Link>

        <div className="tw-flex-1 tw-min-w-0">
          <Link to={`/user/${user._id}`} className="tw-no-underline">
            <p className="tw-truncate tw-text-sm tw-font-semibold tw-text-white tw-m-0">
              {user.firstName} {user.lastName}
            </p>
          </Link>
          {safeHref(user.website) && (
            <a
              href={safeHref(user.website)}
              target="_blank"
              rel="noopener noreferrer"
              className="tw-truncate tw-text-xs tw-text-white/40 hover:tw-text-white/70 tw-transition-colors tw-block"
            >
              {user.website}
            </a>
          )}
        </div>

        <button
          onClick={() => onMessageIconClick(user._id)}
          className="tw-flex-shrink-0 tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-lg tw-bg-[#712CB0]/20 hover:tw-bg-[#712CB0] tw-border tw-border-[#712CB0]/40 tw-text-white/60 hover:tw-text-white tw-transition-all tw-cursor-pointer"
        >
          <FontAwesomeIcon icon={faMessage} className="tw-text-xs" />
        </button>
      </div>

      {/* Comment */}
      {request.comment && (
        <p className="tw-m-0 tw-text-xs tw-text-white/50 tw-bg-white/5 tw-rounded-lg tw-px-3 tw-py-2 tw-border tw-border-white/10">
          {request.comment}
        </p>
      )}

      {/* Status / Actions */}
      <div className="tw-flex tw-items-center tw-gap-2">
        {request.status === "approved" && (
          <span className="tw-rounded-full tw-bg-green-900/30 tw-px-4 tw-py-1 tw-text-xs tw-font-medium tw-text-green-300">
            {t("Approved")}
          </span>
        )}
        {request.status === "refused" && (
          <span className="tw-rounded-full tw-bg-red-900/30 tw-px-4 tw-py-1 tw-text-xs tw-font-medium tw-text-red-300">
            {t("Denied")}
          </span>
        )}
        {request.status === "pending" && (
          <>
            <button
              onClick={onApprove}
              className="tw-flex-1 tw-rounded-full tw-bg-[#712CB0] tw-py-1.5 tw-text-xs tw-font-medium tw-text-white hover:tw-bg-[#8B3FD9] tw-transition-colors tw-border-0 tw-cursor-pointer"
            >
              {t("Approve")}
            </button>
            <button
              onClick={onDeny}
              className="tw-flex-1 tw-rounded-full tw-bg-white/10 tw-py-1.5 tw-text-xs tw-font-medium tw-text-white/70 hover:tw-bg-white/20 tw-transition-colors tw-border-0 tw-cursor-pointer"
            >
              {t("Deny")}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
